import { validateImageFile, resizeImage } from "../utils/imageUtils.ts";

const AvatarCustomizationModal = ({
  show,
  onClose,
  modalAvatar,
  setModalAvatar,
  modalBg,
  setModalBg,
  onDone,
  darkMode = false,
}) => {
  const avatarBgColors = [
    "#f3f4f6", // gray-100
    "#38bdf8", // sky-400
    "#60a5fa", // blue-400
    "#6366f1", // indigo-500
    "#34d399", // green-400
    "#a78bfa", // purple-400
    "#f472b6", // pink-400
    "#f87171", // red-400
    "#fb923c", // orange-400
    "#facc15", // amber-400
  ];

  const isMobile = typeof window !== "undefined" && window.innerWidth <= 767;

  if (!show) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      {isMobile ? (
        <div
          className={`rounded-2xl shadow-xl p-4 w-full max-w-xs flex flex-col gap-4 border-2 mx-2 relative ${
            darkMode
              ? "bg-gray-800 text-gray-100 border-gray-600"
              : "bg-white text-gray-700 border-gray-200"
          }`}
          style={{ margin: "auto" }}
        >
          <button
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-2xl"
            onClick={onClose}
            aria-label="Close"
            style={{ zIndex: 10 }}
          >
            ×
          </button>
          {/* Preview */}
          <div className="flex flex-col items-center justify-center">
            <div
              className={`w-40 h-40 rounded-2xl border-4 overflow-hidden flex items-center justify-center mb-4 ${
                darkMode ? "border-gray-600" : "border-white"
              }`}
              style={{ background: modalBg }}
            >
              <img
                src={
                  modalAvatar ||
                  "/assets/profile-characters/edi-transparent.png"
                }
                alt="Avatar Preview"
                className="w-full h-full object-cover"
              />
            </div>
            <button
              className="mt-1 px-4 py-2 bg-lime-500 text-white rounded-lg hover:bg-lime-600 duration-200 transform hover:-translate-y-0.5 transition-all text-center font-semibold"
              onClick={onDone}
            >
              Selesai
            </button>
          </div>
          {/* Selection */}
          <div className="flex flex-col items-center w-full">
            <input
              type="file"
              accept="image/*"
              onChange={async (e) => {
                // Only update preview, not save
                const file = e.target.files?.[0];
                if (!file) return;
                const validation = validateImageFile(file);
                if (!validation.isValid) {
                  alert(validation.error);
                  return;
                }
                try {
                  const base64 = await resizeImage(file, 400, 400, 0.8);
                  setModalAvatar(base64);
                  setModalBg("");
                } catch (error) {
                  alert("Gagal memproses gambar");
                }
              }}
              className="hidden"
              id="avatar-upload-modal"
            />
            <div className="flex items-center w-full my-3">
              <div
                className={`flex-1 h-px ${
                  darkMode ? "bg-gray-600" : "bg-gray-300"
                }`}
              />
              <span
                className={`mx-3 text-gray-400 font-semibold text-sm select-none`}
              >
                Kustomisasi Avatar
              </span>
              <div
                className={`flex-1 h-px ${
                  darkMode ? "bg-gray-600" : "bg-gray-300"
                }`}
              />
            </div>
            <span className="font-semibold text-sm mb-2">Pilih Karakter</span>
            <div className="grid grid-cols-3 gap-2 justify-center mx-auto w-fit mb-2">
              {[
                "/assets/profile-characters/agus-transparent.png",
                "/assets/profile-characters/edi-transparent.png",
                "/assets/profile-characters/judika-transparent.png",
                "/assets/profile-characters/maria-transparent.png",
                "/assets/profile-characters/poltak-transparent.png",
                "/assets/profile-characters/roger-transparent.png",
              ].map((charUrl) => {
                const selected = modalAvatar === charUrl;
                return (
                  <button
                    key={charUrl}
                    type="button"
                    className={`rounded-2xl border-2 p-1 transition-all
                      ${
                        selected
                          ? darkMode
                            ? "border-blue-500 ring-2 ring-blue-800"
                            : "border-blue-500 ring-2 ring-blue-300"
                          : darkMode
                          ? "border-gray-600 bg-gray-800"
                          : "border-gray-300 bg-white"
                      }
                      flex items-center justify-center`}
                    onClick={() => {
                      setModalAvatar(charUrl);
                      if (!modalBg) setModalBg(avatarBgColors[0]);
                    }}
                  >
                    <img
                      src={charUrl}
                      alt="Avatar Option"
                      className="w-12 h-12 object-cover rounded-2xl"
                    />
                  </button>
                );
              })}
            </div>
            <span className="font-semibold text-sm mb-2">Warna Latar</span>
            <div className="grid grid-cols-5 gap-2 justify-center mx-auto w-fit mb-2">
              {avatarBgColors.map((color) => (
                <button
                  key={color}
                  type="button"
                  className={`w-7 h-7 rounded-lg border-2 transition-all
                    ${
                      modalBg === color
                        ? darkMode
                          ? "border-blue-500 ring-2 ring-blue-800"
                          : "border-blue-500 ring-2 ring-blue-300"
                        : darkMode
                        ? "border-gray-600"
                        : "border-gray-300"
                    }
                  `}
                  style={{ background: color }}
                  onClick={() => setModalBg(color)}
                />
              ))}
            </div>
            <div className="flex items-center w-full my-3">
              <div
                className={`flex-1 h-px ${
                  darkMode ? "bg-gray-600" : "bg-gray-300"
                }`}
              />
              <span
                className={`mx-3 text-gray-400 font-semibold text-sm select-none`}
              >
                Atau
              </span>
              <div
                className={`flex-1 h-px ${
                  darkMode ? "bg-gray-600" : "bg-gray-300"
                }`}
              />
            </div>
            <label
              htmlFor="avatar-upload-modal"
              className="w-full px-4 py-2 bg-blue-500 text-white rounded-lg cursor-pointer hover:bg-blue-600 duration-200 transform hover:-translate-y-0.5 transition-all text-center font-semibold"
            >
              Pilih dari Perangkat
            </label>
          </div>
        </div>
      ) : (
        <div
          className={`rounded-2xl shadow-xl p-4 w-full max-w-lg relative flex flex-row gap-4 border-2
            ${
              darkMode
                ? "bg-gray-800 text-gray-100 border-gray-600"
                : "bg-white text-gray-700 border-gray-200"
            }
          `}
        >
          <button
            className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-xl"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
          {/* Preview Left */}
          <div className="flex flex-col items-center justify-center flex-1 min-w-[120px]">
            <div
              className={`w-48 h-48 rounded-2xl border-4 overflow-hidden flex items-center justify-center mb-4 ${
                darkMode ? "border-gray-600" : "border-white"
              }`}
              style={{ background: modalBg }}
            >
              <img
                src={
                  modalAvatar ||
                  "/assets/profile-characters/edi-transparent.png"
                }
                alt="Avatar Preview"
                className="w-full h-full object-cover"
              />
            </div>
            <button
              className="mt-1 px-3 py-2 bg-lime-500 text-white rounded-lg hover:bg-lime-600 duration-200 transform hover:-translate-y-0.5 transition-all text-center font-semibold text-base"
              onClick={onDone}
            >
              Selesai
            </button>
          </div>
          {/* Selection Right */}
          <div className="flex flex-col flex-[2] min-w-[160px] max-w-[220px]">
            <input
              type="file"
              accept="image/*"
              onChange={async (e) => {
                // Only update preview, not save
                const file = e.target.files?.[0];
                if (!file) return;
                const validation = validateImageFile(file);
                if (!validation.isValid) {
                  alert(validation.error);
                  return;
                }
                try {
                  const base64 = await resizeImage(file, 400, 400, 0.8);
                  setModalAvatar(base64);
                  setModalBg("");
                } catch (error) {
                  alert("Gagal memproses gambar");
                }
              }}
              className="hidden"
              id="avatar-upload-modal"
            />
            <div className="flex items-center w-full mb-2 mt-5">
              <div
                className={`flex-1 h-px ${
                  darkMode ? "bg-gray-600" : "bg-gray-300"
                }`}
              />
              <span
                className={`mx-3 font-semibold text-xs select-none ${
                  darkMode ? "text-gray-400" : "text-gray-400"
                }`}
              >
                Kustomisasi Avatar
              </span>
              <div
                className={`flex-1 h-px ${
                  darkMode ? "bg-gray-600" : "bg-gray-300"
                }`}
              />
            </div>
            <span className="font-semibold text-xs mb-2">Pilih Karakter</span>
            <div className="grid grid-cols-3 gap-2 justify-center mb-2">
              {[
                "/assets/profile-characters/agus-transparent.png",
                "/assets/profile-characters/edi-transparent.png",
                "/assets/profile-characters/judika-transparent.png",
                "/assets/profile-characters/maria-transparent.png",
                "/assets/profile-characters/poltak-transparent.png",
                "/assets/profile-characters/roger-transparent.png",
              ].map((charUrl) => {
                const selected = modalAvatar === charUrl;
                return (
                  <button
                    key={charUrl}
                    type="button"
                    className={`rounded-2xl border-2 p-1 transition-all
                      ${
                        selected
                          ? darkMode
                            ? "border-blue-500 ring-2 ring-blue-800"
                            : "border-blue-500 ring-2 ring-blue-300"
                          : darkMode
                          ? "border-gray-600 bg-gray-800"
                          : "border-gray-300 bg-white"
                      }
                      flex items-center justify-center`}
                    onClick={() => {
                      setModalAvatar(charUrl);
                      if (!modalBg) setModalBg(avatarBgColors[0]);
                    }}
                  >
                    <img
                      src={charUrl}
                      alt="Avatar Option"
                      className="w-12 h-12 object-cover rounded-2xl"
                    />
                  </button>
                );
              })}
            </div>
            <span className="font-semibold text-xs mb-2">Warna Latar</span>
            <div className="grid grid-cols-5 gap-2 justify-center mb-1">
              {avatarBgColors.map((color) => (
                <button
                  key={color}
                  type="button"
                  className={`w-6 h-6 rounded-lg border-2 transition-all
                    ${
                      modalBg === color
                        ? darkMode
                          ? "border-blue-500 ring-2 ring-blue-800"
                          : "border-blue-500 ring-2 ring-blue-300"
                        : darkMode
                        ? "border-gray-600"
                        : "border-gray-300"
                    }
                `}
                  style={{ background: color }}
                  onClick={() => setModalBg(color)}
                />
              ))}
            </div>
            <div className="flex items-center w-full my-3">
              <div
                className={`flex-1 h-px ${
                  darkMode ? "bg-gray-600" : "bg-gray-300"
                }`}
              />
              <span
                className={`mx-3 text-gray-400 font-semibold text-xs select-none`}
              >
                Atau
              </span>
              <div
                className={`flex-1 h-px ${
                  darkMode ? "bg-gray-600" : "bg-gray-300"
                }`}
              />
            </div>
            <label
              htmlFor="avatar-upload-modal"
              className="w-full px-3 py-2 bg-blue-500 text-white rounded-lg cursor-pointer hover:bg-blue-600 duration-200 transform hover:-translate-y-0.5 transition-all text-center font-semibold text-base"
            >
              Pilih dari Perangkat
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default AvatarCustomizationModal;
